import {
  type UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/vue-query'
import type { AxiosResponse } from 'axios'
import type { Ref } from 'vue'
import type { ReviewMessagePayload } from '../../types/api/payload/reviewMessage'
import type { ReadReviewMessageSuccessResponse } from '../../types/api/response/reviewMessage'
import type { MessageType } from '../../types/model/reviewMessage'
import { REVIEW_MESSAGES_QUERY_KEY } from '../queries'
import { axiosInstance } from '@/modules/Core/plugins/axios'

const ENDPOINT = '/ReviewMessage/Read'

export function readReviewMessage(payload: ReviewMessagePayload) {
  return axiosInstance.put<ReadReviewMessageSuccessResponse>(ENDPOINT, payload)
}

export function useReadReviewMessageMutation(
  type: Ref<MessageType>,
  query?: Ref<string>,
  options?: UseMutationOptions<
    AxiosResponse<ReadReviewMessageSuccessResponse>,
    AxiosCustomError,
    ReviewMessagePayload,
    any
  >
) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: ReviewMessagePayload) => readReviewMessage(payload),
    ...options,
    async onSuccess() {
      await queryClient.invalidateQueries({
        queryKey: [REVIEW_MESSAGES_QUERY_KEY, type, query],
        type: 'all',
      })
    },
  })
}
